import React, { useEffect, useState } from 'react';
import SingleDetail from '../singleDetail/SingleDetail';

const Details = () => {
    const [details, setDetails]=useState([])
    useEffect(()=>{
        fetch("./fakeData.json")
        .then(res=>res.json())
        .then(data=> setDetails(data))
    },[])
    return (
       <div className="bg-warning bg-opacity-10 p-5">
            <div className="container mt-5"> 
        <h1 className="text-danger">WHAT SERVICES WE PROVIDE</h1>
        <div className="row row-cols-1 row-cols-md-2 g-4">
            {
        details.slice(0,6).map(detail=><SingleDetail detail={detail} key={detail.id}></SingleDetail>)
            }
        </div>
        </div>
       </div>
    );
};

export default Details;